<template>
  <AddRule />
</template>
<script>
import appConfig from '@/app.config'
import AddRule from '../../../components/dadban/rules/AddRule.vue'
export default {
  page: {
    title: 'اضافه کردن قوانین',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-rules',
  components: {
    AddRule,
  },
}
</script>
